<template>
  <div class="page-shell">
    <v-list subheader two-line>
      <v-card class="page-toolbar" flat>
        <b-row>
          <b-col cols="3">
            <v-text-field label="Referência" placeholder="Não informado" outlined v-model="referencia" :value="referencia"
              hide-details="auto" dark type="month"></v-text-field>
          </b-col>
          <b-col cols="2">
            <v-text-field label="Vencimento" placeholder="Não informado" outlined v-model="data_venc" :value="data_venc"
              hide-details="auto" dark type="date"></v-text-field>
          </b-col>
          <b-col cols="2">
            <v-btn block x-large color="primary" @click="BuscarFaturamento">
              <v-icon>mdi-magnify</v-icon>&nbsp; Buscar
            </v-btn>
          </b-col>
          <b-col cols="2">
            <v-btn block x-large outlined @click="GerarFaturamento">
              <v-icon>mdi-cogs</v-icon>&nbsp; Gerar
            </v-btn>
          </b-col>
        </b-row>
      </v-card>

      <v-tabs v-model="tab" class="page-tabs">
        <v-tab> Faturamento Gerado </v-tab>
        <v-tab> Relatórios </v-tab>
        <v-tab> Log de envio </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <div class="painelContainer">
            <h6 v-if="lst_faturamento.length == 0">
              Nenhuma visualização disponível
            </h6>

            <div v-else>
              <b-row>
                <b-col cols="3">
                  <v-btn block color="primary" @click="openDialogBoletos">
                    <v-icon>mdi-docs</v-icon>&nbsp; Emitir boletos
                  </v-btn>
                </b-col>
              </b-row>

              <v-divider></v-divider>

              <b-row>
                <b-col cols="8"></b-col>
                <b-col cols="4">
                  <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                    hide-details></v-text-field>
                </b-col>
              </b-row>

              <v-data-table :headers="headers" :items="lst_faturamento" class="elevation-1" :search="search"
                :items-per-page="10">
                <!-- hide-default-footer
                :page.sync="page"
                @page-count="pageCount = $event" -->
                <template v-slot:item.acoes="{ item }">
                  <!-- <v-btn color="primary" icon>
                    <v-icon>mdi-email</v-icon>
                  </v-btn> -->
                  <v-btn color="grey darken-4" class="table-icon-btn" @click="ImprimeBoleto(item)" icon>
                    <v-icon>mdi-file-pdf-box</v-icon>
                  </v-btn>

                  <v-btn color="grey darken-4" class="table-icon-btn" @click="EnvioWhats(item)" icon>
                    <v-icon>mdi-whatsapp</v-icon>
                  </v-btn>

                  <v-btn color="grey darken-4" class="table-icon-btn" @click="AcoesFaturamento(item)" icon>
                    <v-icon>mdi-file-document-check</v-icon>
                  </v-btn>
                </template>
                <template v-slot:item.memoria="{ item }">
                  <!-- <v-btn color="primary" icon>
                    <v-icon>mdi-email</v-icon>
                  </v-btn> -->
                  <v-btn color="grey darken-4" class="table-icon-btn" @click="viewMemoriaCalculo(item)" icon>
                    <v-icon>mdi-calculator</v-icon>
                  </v-btn>
                </template>
                <template v-slot:item.excluir="{ item }">
                  <!-- <v-btn color="primary" icon>
                    <v-icon>mdi-email</v-icon>
                  </v-btn> -->
                  <v-btn color="red darken-4" class="table-icon-btn" @click="excluirFaturamento(item)" icon>
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
              <!-- <div class="text-center pt-2">
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
              </div> -->

              <v-divider></v-divider>

              <b-row>
                <b-col cols="4">
                  <v-card>
                    <v-card-title>Valor Total </v-card-title>
                    <v-card-text>
                      <h5>{{ formatMoney(total_faturamento) }}</h5>
                    </v-card-text>
                  </v-card>
                </b-col>
                <b-col cols="4">
                  <v-card>
                    <v-card-title>Número de clientes</v-card-title>
                    <v-card-text>
                      <h5>{{ lst_faturamento.length }}</h5>
                    </v-card-text>
                  </v-card>
                </b-col>
              </b-row>
              <v-dialog v-model="dialog_memoria" hide-overlay transition="dialog-top-transition" max-width="500">
                <v-card>
                  <v-toolbar dark color="grey darken-3">
                    <v-toolbar-title> Memória de calculo </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialog_memoria = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <b-container>
                    <div v-for="(i, idx) in memoria_lst" :key="idx">
                      <b-row>
                        <b-col cols="8">{{ i.descricao }}</b-col>
                        <b-col cols="4">{{ i.valor }}</b-col>
                      </b-row>
                      <v-divider></v-divider>
                    </div>
                  </b-container>
                </v-card>
              </v-dialog>
              <v-dialog v-model="modal_nfse" hide-overlay transition="dialog-top-transition" max-width="500">
                <v-card>
                  <v-toolbar dark color="grey darken-3">
                    <v-toolbar-title> Emissão NFS-e </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="modal_nfse = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <b-container>
                    <b-row>
                      <b-col> {{ item_nfse.nome_cli }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col> NroDoc: {{ item_nfse.nrodoc }}</b-col>
                      <b-col> Numero NFSe: {{ item_nfse.numero_nfse }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="4">
                        <v-text-field v-model="nro_nfse"  label="Número RPS"
                            ></v-text-field>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col> Valor: {{ item_nfse.valor }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <InputNumeric id="valor" label="% Serviço" :value="per_iss" @onInput="getNumeric" />
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col></b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <v-btn block @click="EmitirNfse" color="grey darken-4" dark>
                          <v-icon>mdi-file-document-check</v-icon>&nbsp; Emitir
                          NFS-e
                        </v-btn>
                      </b-col>
                      <b-col>
                        <v-btn block @click="DelNfsePergunta" color="danger">
                          <v-icon>mdi-file-document-check</v-icon>&nbsp;
                          Cancelar NFS-e
                        </v-btn>
                      </b-col>
                    </b-row>
                  </b-container>
                </v-card>
              </v-dialog>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item>
          <v-btn block x-large @click="modal_enviaremail = true">
            <v-icon>mdi-cogs</v-icon>&nbsp; Enviar E-mail em Lote
          </v-btn>
          <br>
          <v-btn block x-large @click="ImpFaturamento">
            <v-icon>mdi-cogs</v-icon>&nbsp; Relatório do Faturamento
          </v-btn>
          <br>
          <v-btn block x-large @click="BuscarLstsigtef">
            <v-icon>mdi-cogs</v-icon>&nbsp; Relatório com valores TEF, Sig
          </v-btn>
          <br>
          <v-btn block x-large @click="BuscarLstDistrib">
            <v-icon>mdi-cogs</v-icon>&nbsp; Relatório por Distribuidor
          </v-btn>
          <br>
          <v-btn block x-large @click="BuscarClientesAtendimentoSMnt">
            <v-icon>mdi-cogs</v-icon>&nbsp; Relatório Atendimentos Clientes sem manutenção
          </v-btn>
          <br>
        </v-tab-item>
        <v-tab-item>
          <v-btn block x-large @click="getLog">
            <v-icon>mdi-refresh</v-icon>&nbsp; Atualizar Log
          </v-btn>
          <v-divider></v-divider>
          <b-row>
            <b-col cols="8"></b-col>
            <b-col cols="4">
              <v-text-field v-model="searchlog" append-icon="mdi-magnify" label="Buscar" single-line
                hide-details></v-text-field>
            </b-col>
          </b-row>
          <v-data-table :headers="headers_log" :items="log" class="elevation-1" :items-per-page="10" :search="searchlog">
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-list>

    <v-dialog v-model="modal_boletos" max-width="1200" scrollable transition="dialog-top-transition" :hide-overlay="true">
      <v-card>
        <v-card-title>
          <b-row>
            <h5>Selecione o banco</h5>
          </b-row>
        </v-card-title>
        <v-card-text>
          <b-container fluid>
            <br />
            <b-row>
              <b-col>
                <AutoBuscaDrop id="codbco" item_id="codbco" item_text="nome" item_pk="codbco" item_campos="codbco,nome"
                  item_busca="codbco|| '-' || TRIM(UPPER(nome)) " item_left="" item_ordem="nome" item_condicao=""
                  tabela="bancos" :value="codbco" @getID="getID" :label="'Banco'" />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <v-text-field label="Assunto E-mail" placeholder="Não informado" outlined v-model="assunto_email" :value="assunto_email"
                    hide-details="auto"></v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <Editor v-model="corpo_email" editorStyle="height: 150px">
                </Editor>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <v-btn block @click="GerarBoletos(2)" color="grey darken-4" dark>
                  <v-icon>mdi-file-document-check</v-icon>&nbsp; Download da
                  Remessa
                </v-btn>
              </b-col>
              <b-col cols="4">
                <v-btn block @click="GerarBoletos(3)" color="grey darken-4" dark>
                  <v-icon>mdi-email</v-icon>&nbsp; Enviar E-mail com Boletos
                </v-btn>
              </b-col>
             <!--  <b-col cols="4">
                <v-btn block @click="GerarBoletos(1)" color="grey darken-4" dark>
                  <v-icon>mdi-file-document-check</v-icon>&nbsp; Download dos
                  boletos
                </v-btn>
              </b-col> -->
            </b-row>
          </b-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modal_whats" max-width="500" scrollable transition="dialog-top-transition" :hide-overlay="true">
      <v-card>
        <v-card-title>
          <b-row>
            <h5>Informe numero do telefone</h5>
          </b-row>
        </v-card-title>
        <v-card-text>
          <b-container fluid>
            <br />
            <b-row>
              <b-col>
                <v-text-field v-model="whats_fone" v-mask="['(##)#####-####']" label="Fone no formato: (XX) XXXXX-XXXX"
                  single-line hide-details></v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <v-btn block @click="EnvioWhats2()" color="grey darken-4" dark>
                  <v-icon>mdi-file-document-check</v-icon>&nbsp; Enviar Whats
                </v-btn>
              </b-col>
            </b-row>
          </b-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modal_distribuidor" hide-overlay transition="dialog-top-transition" scrollable>
      <v-card>
        <v-card-title>
          <b-row>
            <b-col cols="3">
              <v-text-field label="Referência" placeholder="Não informado" outlined v-model="referencia_distrib"
                :value="referencia_distrib" hide-details="auto" type="month"></v-text-field>
            </b-col>

            <b-col cols="3">
              <v-btn x-large @click="BuscarLstDistrib">
                <v-icon>mdi-list-box</v-icon>
                Buscar
              </v-btn>
            </b-col>
            <b-col cols="4"></b-col>
            <b-col cols="2" :style="{ padding: '10px' }" class="text-right">
              <v-btn @click="modal_distribuidor = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </b-col>
          </b-row>
        </v-card-title>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modal_sigtef" hide-overlay transition="dialog-top-transition" scrollable>
      <v-card>
        <v-card-title>
          <b-row>
            <b-col cols="3">
              <v-text-field label="Referência" placeholder="Não informado" outlined v-model="referencia_sigtef"
                :value="referencia_sigtef" hide-details="auto" type="month"></v-text-field>
            </b-col>

            <b-col cols="3">
              <v-btn x-large @click="BuscarLstsigtef">
                <v-icon>mdi-list-box</v-icon>
                Buscar
              </v-btn>
            </b-col>
            <b-col cols="4"></b-col>
            <b-col cols="2" :style="{ padding: '10px' }" class="text-right">
              <v-btn @click="modal_sigtef = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </b-col>
          </b-row>
        </v-card-title>
      </v-card>
    </v-dialog>


    <v-dialog v-model="modal_clienteSMnt" max-width="800" :hide-overlay="true" transition="dialog-top-transition"
      scrollable>
      <v-card>
        <v-card-title>
          <b-row>
            <b-col cols="10">
              <strong>Clientes com atendimentos no periodo sem manutenção</strong>
            </b-col>
            <b-col cols="2" :style="{ padding: '10px' }" class="text-right">
              <v-btn @click="modal_clienteSMnt = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </b-col>
          </b-row>
        </v-card-title>
        <v-card-text style="max-height: 500px">
          <b-container fluid>
            <br>
            <div v-for="(i, idx) in data_clientesmnt" :key="idx">
              <b-row>
                <b-col cols="8">{{ i.nome }}</b-col>
                <b-col cols="4">
                  <v-btn icon @click="BuscarExtratoAtendimentoSMnt(i.id)">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </b-col>
              </b-row>
              <v-divider></v-divider>

            </div>
          </b-container>
        </v-card-text>
        <v-card-actions>

        </v-card-actions>

      </v-card>
    </v-dialog>


    <v-dialog v-model="modal_enviaremail" max-width="1200" scrollable transition="dialog-top-transition" :hide-overlay="true">
      <v-card>
        <v-card-title>
          <b-row>
            <h5>Enviar E-mail em lote</h5>
          </b-row>
        </v-card-title>
        <v-card-text>
          <b-container fluid>
            <br />
           
            <b-row>
              <b-col cols="12">
                <v-text-field label="Assunto E-mail" placeholder="Não informado" outlined v-model="assunto_email" :value="assunto_email"
                    hide-details="auto"></v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <Editor v-model="corpo_email" editorStyle="height: 150px">
                </Editor>
              </b-col>
            </b-row>
            <b-row>
             
              <b-col cols="4">
                <v-btn block @click="enviarEmail()" color="grey darken-4" dark>
                  <v-icon>mdi-file-document-check</v-icon>&nbsp; Enviar E-Mail
                </v-btn>
              </b-col>
            </b-row>
          </b-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Vue from "vue";
//import AutoBusca from "../components/AutoBusca.vue";
import AutoBuscaDrop from "../components/AutoBuscaDrop.vue";
import Faturamento from "../domain/Faturamento";
import NFse from "../domain/NFse";
import FaturamentoRels from "../domain/FaturamentoRels";
import FaturamentoRels2 from "../domain/FaturamentoRels2";
import { mapGetters } from "vuex";
import { saveAs } from "@progress/kendo-file-saver";
import InputNumeric from "../components/InputNumeric.vue";
import Editor from "primevue/editor";
import ExecutaSQL from "../domain/ExecutaSQL";

export default {
  data: () => ({
    page: 1,
    pageCount: 0,
    search: "",
    searchlog: "",
    codbco: "",
    referencia: "",
    data_venc: "",
    ZipBoletos: false,
    RemessaBoletos: false,
    EmailBoletos: false,
    BoletosRar: false,
    tab: 0,
    lst_faturamento: [],
    headers: [
      {
        text: "NroDoc",
        align: "start",
        sortable: true,
        value: "nrodoc",
      },
      {
        text: "NroNFSE",
        align: "start",
        sortable: true,
        value: "numero_nfse",
      },
      {
        text: "Cliente",
        align: "start",
        sortable: true,
        value: "nome_cli",
      },
      {
        text: "Banco",
        align: "start",
        sortable: false,
        value: "codbco",
      },
      {
        text: "Gerador",
        align: "start",
        sortable: false,
        value: "nome_login",
      },
      {
        text: "",
        align: "start",
        sortable: false,
        value: "acoes",
      },
      {
        text: "Data Refer",
        align: "start",
        sortable: false,
        value: "referencia",
      },
      {
        text: "Vencimento",
        align: "start",
        sortable: false,
        value: "data_venc",
      },
      {
        text: "Memória",
        align: "start",
        sortable: false,
        value: "memoria",
      },
      {
        text: "Valor",
        align: "start",
        sortable: false,
        value: "valor",
      },
      {
        text: "",
        align: "start",
        sortable: false,
        value: "excluir",
      },
    ],
    headers_log: [
      {
        text: "Perfil",
        align: "start",
        sortable: true,
        value: "id_perfil",
      },
      {
        text: "Data Gerado",
        align: "start",
        sortable: false,
        value: "datac",
      },
      {
        text: "Situação",
        align: "start",
        sortable: false,
        value: "foiemail",
      },
      {
        text: "Email",
        align: "start",
        sortable: false,
        value: "email",
      },
      {
        text: "Observação",
        align: "start",
        sortable: false,
        value: "observacao",
      },
    ],
    dialog_memoria: false,
    memoria_lst: [],
    total_faturamento: 0,
    modal_boletos: false,
    log: [],
    modal_nfse: false,
    item_nfse: {},
    per_iss: 0,
    nfse_obs: "",
    modal_whats: false,
    id_contrato: null,
    whats_fone: "",
    modal_distribuidor: false,
    referencia_distrib: "",
    referencia_sigtef:"",
    modal_sigtef: false,
    modal_clienteSMnt: false,
    referencia_smnt: "",
    data_clientesmnt: [],
    assunto_email: "",
    corpo_email: "",
    modal_enviaremail: false,
    nro_nfse:"",
  }),
  components: { AutoBuscaDrop, InputNumeric, Editor },
  computed: {
    ...mapGetters("Usuarios", ["getUsuario"]),
    getUser: function () {
      return this.getUsuario();
    },
  },
  watch: {
    lst_faturamento: function (val) {
      this.calculaTotais(val);
    },
  },
  created() {
    if (this.getUser.nivel > 1) {
      this.$router.replace({ name: "restrito" });
    }
  },
  mounted() { },
  methods: {
    getID(val) {
      if (val.id == "codbco") {
        if (val.value != null && val.value != "") {
          this.codbco = val.value;
        }
      }
    },
    getNumeric(val) {
      if (val.id == "valor") {
        this.per_iss = val.value;
      }
    },
    openDialogBoletos() {
      this.modal_boletos = true;
    },
    GerarFaturamento() {
      var vm = this;
      Vue.Pergunta(
        vm,
        "Calcular Faturamento",
        "Deseja Calcular o faturamento com valores atualizados?",
        function () {
          vm.GerarFaturamento2();
        },
        null
      );
    },
    GerarFaturamento2() {
      if (this.validaCampos()) return;
      this.retObjectReq.cod_contrato = "";
      Vue.Loading("", "", this);
      this.service = new Faturamento(this.$resource);
      this.service.geraFaturamento(this.retObjectReq()).then(
        function (tmp) {
          this.lst_faturamento = tmp;
          Vue.CloseLoading(this);
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    },
    excluirFaturamento(item) {
      console.log(item);
      var vm = this;
      Vue.Pergunta(
        vm,
        "Excluir Movimento",
        "Deseja o movimento do faturamento?",
        function () {
          vm.excluirFaturamento2(item);
        },
        null
      );
    },
    excluirFaturamento2(item) {
      Vue.Loading("", "", this);
      this.service = new Faturamento(this.$resource);
      this.service.delete(item.id, item.cod_contrato, item.referencia).then(
        function (tmp) {
          Vue.CloseLoading(this);
          if (tmp.cStat == "-9") {
            Vue.Mensagem(this, "OPs", tmp.xMotivo);
            return;
          }

          this.BuscarFaturamento();
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    },
    BuscarFaturamento() {
      if (this.validaCamposBusca()) return;

      Vue.Loading("", "", this);
      this.service = new Faturamento(this.$resource);
      this.service.getFaturamento(this.codbco, this.referencia).then(
        function (tmp) {
          this.lst_faturamento = tmp;
          Vue.CloseLoading(this);
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    },
    AcoesFaturamento(item) {
      this.item_nfse = {};
      this.item_nfse = item;
      this.modal_nfse = true;

      Vue.Loading("", "", this);
      this.service = new ExecutaSQL(this.$resource);
      this.service.get("SELECT numero_nfse FROM bcosta").then(
        function (tmp) {
          Vue.CloseLoading(this);
          if(tmp.length > 0) this.nro_nfse = tmp[0].numero_nfse;
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );

    },
    EmitirNfse() {
      Vue.Loading("", "", this);
      this.service = new NFse(this.$resource);
      this.service.getNfse(this.item_nfse.id, this.per_iss, this.nfse_obs, this.nro_nfse).then(
        function (tmp) {
          Vue.CloseLoading(this);
          
          if(tmp.cStat != "100") {
            Vue.Mensagem(this, "OPs", tmp.xMotivo);
            return;
          }

          this.item_nfse.numero_nfse = tmp.nNF;
          var wDown = tmp.retContArquivoPDF;
          var wNome = tmp.retNomeArquivo + ".pdf";
          const dataURI = "data:text/plain;base64," + wDown;
          saveAs(dataURI, wNome);
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    },
    DelNfsePergunta() {
      var vm = this;
      Vue.Pergunta(
        vm,
        "Cancelamento",
        "Deseja cancelar a NFse?",
        function () {
          vm.DelNfse();
        },
        null
      );
    },
    DelNfse() {
      Vue.Loading("", "", this);
      this.service = new NFse(this.$resource);
      this.service.delNfse(this.item_nfse.id).then(
        function (tmp) {
          Vue.CloseLoading(this);
          if (tmp.cStat == "-9") {
            Vue.Mensagem(this, "OPs", tmp.xMotivo);
            return;
          }

          Vue.Mensagem(this, "Cancelada", tmp.xMotivo);
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    },
    ImprimeBoleto(item) {
      Vue.Loading("", "", this);
      this.service = new Faturamento(this.$resource);
      this.service
        .impBoleto(
          item.codbco,
          item.referencia,
          item.data_venc,
          item.cod_contrato
        )
        .then(
          function (tmp) {
            var wDown = tmp.BoletoPDF;
            var wNome = item.nrodoc + ".pdf";
            const dataURI = "data:text/plain;base64," + wDown;
            saveAs(dataURI, wNome);

            Vue.CloseLoading(this);
          },
          (err) => {
            Vue.CloseLoading(this);
            console.log(err);
          }
        );
    },
    EnvioWhats(item) {

      console.log(item);
      this.id_contrato = item.cod_contrato;
      this.whats_fone = item.fone_cli;
      this.modal_whats = true;



    },
    EnvioWhats2() {

      Vue.Loading("", "", this);
      this.service = new FaturamentoRels(this.$resource);
      this.service.getWhats(this.id_contrato, this.whats_fone, this.referencia).then(
        function (tmp) {
          console.log(tmp);
          Vue.CloseLoading(this);
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );

    },
    GerarBoletos(oper) {
      if (this.validaCampos()) return;

      if (this.codbco == null || this.codbco == "") {
        Vue.Mensagem(
          this,
          "Validação",
          "Selecione o banco para gerar faturamento"
        );
        return true;
      }

      this.ZipBoletos = false;
      this.RemessaBoletos = false;
      this.EmailBoletos = false;
      this.BoletosRar = false;
      var msg = "";
      if (oper == 1) {
        this.BoletosRar = true;
        msg = "Deseja fazer o download dos boletos?";
      }
      if (oper == 2) {
        this.RemessaBoletos = true;
        msg = "Deseja gerar a remessa do faturamento gerado?";
      }
      if (oper == 3) {
        this.EmailBoletos = true;
        msg = "Deseja enviar e-mail com boleto para os clientes";
      }

      var vm = this;
      Vue.Pergunta(
        vm,
        "Confirmar processo",
        msg,
        function () {
          vm.getBoletos(oper);
        },
        null
      );
      //this.getBoletos(oper);
    },
    ImpFaturamento() {
      Vue.Loading("", "", this);
      this.service = new FaturamentoRels(this.$resource);
      this.service.getFaturamento(this.codbco, this.referencia).then(
        function (tmp) {
          console.log(tmp);
          Vue.impRel("Faturamento", tmp);
          Vue.CloseLoading(this);
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    },
    enviarEmail(){
      Vue.Loading("", "", this);
      this.service = new Faturamento(this.$resource);
      this.service
        .enviaEmail(
          this.assunto_email,
          this.corpo_email,
          this.referencia
        )
        .then(
          function () {
            
            Vue.CloseLoading(this);
          },
          (err) => {
            Vue.CloseLoading(this);
            console.log(err);
          }
        );
    },
    getLog() {
      Vue.Loading("", "", this);
      this.service = new Faturamento(this.$resource);
      this.service.getLog(this.referencia).then(
        function (tmp) {
          console.log(tmp);
          this.log = JSON.parse(tmp);
          Vue.CloseLoading(this);
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    },
    getBoletos(oper) {
      Vue.Loading("", "", this);
      this.service = new Faturamento(this.$resource);
      this.service.getBoletos(this.retObjectReq()).then(
        function (tmp) {
          // Download da Remessa
          var wDown;
          var wNome;
          if (oper == 2) {
            wDown = tmp.ArquivoRemessaBase64;
            wNome = tmp.NomeRemessa;
            const dataURI = "data:text/plain;base64," + wDown;
            saveAs(dataURI, wNome);
          } else if (oper == 3) {
            Vue.Mensagem(this, "Resposta", tmp.Motivo);
          } else if (oper == 1) {
            wDown = tmp.ArquivoRemessaBase64;
            wNome = tmp.NomeRemessa;
            const dataURI = "data:application/octet-stream;base64," + wDown;
            saveAs(dataURI, wNome);
          }
          Vue.CloseLoading(this);
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    },
    calculaTotais(tmp) {
      console.log(tmp);
      var wtotal = 0;
      this.total_faturamento = 0;
      for (var i = 0; i < tmp.length; i++) wtotal += tmp[i].valor;
      this.total_faturamento = wtotal;
    },
    Download() {
      const dataURI = "data:text/plain;base64," + Vue.btoa("TEste");
      saveAs(dataURI, "Arquivo.txt");
    },
    validaCampos() {
      /* if (this.codbco == null || this.codbco == "") {
        Vue.Mensagem(
          this,
          "Validação",
          "Selecione o banco para gerar faturamento"
        );
        return true;
      } */
      if (this.referencia == null || this.referencia == "") {
        Vue.Mensagem(
          this,
          "Validação",
          "Informe o mês referência para geração"
        );
        return;
      }
      if (this.data_venc == null || this.data_venc == "") {
        Vue.Mensagem(
          this,
          "Validação",
          "Informe a data de vencimento para os boletos"
        );
        return true;
      }

      return false;
    },
    validaCamposBusca() {

      if (this.referencia == null || this.referencia == "") {
        Vue.Mensagem(
          this,
          "Validação",
          "Informe o mês referência para geração"
        );
        return;
      }

      return false;
    },
    retObjectReq() {
      return {
        id_login: this.getUser.id,
        codbco: this.codbco,
        referencia: this.referencia,
        data_venc: this.data_venc,
        cod_contrato: "",
        ZipBoletos: this.ZipBoletos,
        RemessaBoletos: this.RemessaBoletos,
        EmailBoletos: this.EmailBoletos,
        BoletosRar: this.BoletosRar,
        assunto: this.assunto_email,
        corpo: window.btoa(this.corpo_email)
      };
    },
    viewMemoriaCalculo(item) {
      Vue.Loading("", "", this);
      this.service = new Faturamento(this.$resource);
      this.service.getMemoria(item.cod_contrato, item.referencia, "").then(
        function (tmp) {
          console.log(tmp);
          this.memoria_lst = tmp;
          Vue.CloseLoading(this);
          this.dialog_memoria = true;
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    },
    formatMoney(val) {
      return Vue.MascaraMonetaria(val);
    },
    BuscarLstDistrib() {

      if (this.referencia == "") {
        Vue.Mensagem(this, "Referência", "Preencha a data referência");
        return;
      }

      Vue.Loading("", "", this);
      this.service = new FaturamentoRels(this.$resource);
      this.service.getDistrib(this.referencia).then(
        function (tmp) {
          Vue.CloseLoading(this);
          console.log(tmp);
          Vue.impRel("Faturamento", tmp);
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    },
    BuscarLstsigtef() {

      if (this.referencia == "") {
        Vue.Mensagem(this, "Referência", "Preencha a data referência");
        return;
      }

      Vue.Loading("", "", this);
      this.service = new FaturamentoRels(this.$resource);
      this.service.getValores(this.referencia, "1", "2", "3").then(
        function (tmp) {
          Vue.CloseLoading(this);
          console.log(tmp);
          Vue.impRel("Faturamento", tmp);
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    },
    openModalsmnt() {
      this.data_clientesmnt = [];
      this.modal_clienteSMnt = true;
    },
    BuscarClientesAtendimentoSMnt() {

      if (this.referencia == "") {
        Vue.Mensagem(this, "Referência", "Preencha a data referência");
        return;
      }

      Vue.Loading("", "", this);
      this.service = new FaturamentoRels2(this.$resource);
      this.service.getClientesSMnt(this.referencia).then(
        function (tmp) {
          Vue.CloseLoading(this);
          console.log(tmp);
          this.data_clientesmnt = tmp;
          this.modal_clienteSMnt = true;
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    },
    BuscarExtratoAtendimentoSMnt(id) {
      Vue.Loading("", "", this);
      this.service = new FaturamentoRels2(this.$resource);
      this.service.getExtratoSMnt(this.referencia, id).then(
        function (tmp) {
          Vue.CloseLoading(this);
          console.log(tmp);
          Vue.impRel("Faturamento", tmp);
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    }
  },
};
</script>
